var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wizard__wrap"},[_c('div',{staticClass:"wizard__block wizard__block--thank"},[_c('div',{staticClass:"wizard__block-title"},[_vm._v("\n            The new SOW has been successfully uploaded. Thank you!\n        ")])])])
}]

export { render, staticRenderFns }